"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.search");
var _physical_card = require("@/api/community/physical_card.js");
var _gift_card = require("@/api/community/gift_card.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PhysicalCardListPane',
  props: {
    imgAccessDomain: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      total: 0,
      tableData: [],
      listQuery: {
        keywords: '',
        cardTypeName: '',
        openShopName: '',
        page: 1,
        limit: 20
      },
      imageDialogVisible: false,
      imageSaving: false,
      imageUploading: false,
      currentImageUrl: '',
      currentEditRow: null,
      uploadedImagePath: ''
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    handleFilter: function handleFilter() {
      var _this = this;
      this.loading = true;
      (0, _physical_card.getPhysicalCardPage)(this.listQuery).then(function (res) {
        _this.tableData = res.records || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    viewCardList: function viewCardList(row) {
      this.$emit('toCardList', row.fnId, row.cardTypeName);
    },
    editCardImage: function editCardImage(row) {
      this.currentEditRow = row;
      this.currentImageUrl = row.img ? this.imgAccessDomain + row.img : '';
      this.uploadedImagePath = row.img || '';
      this.imageDialogVisible = true;
    },
    handleImageClose: function handleImageClose() {
      this.imageDialogVisible = false;
      this.currentEditRow = null;
      this.currentImageUrl = '';
      this.uploadedImagePath = '';
    },
    handleCardImageClick: function handleCardImageClick() {
      this.$refs.cardImageInput.click();
    },
    handleCardImageChange: function handleCardImageChange(event) {
      var files = event.target.files;
      if (files.length === 0) return;
      var file = files[0];
      if (this.validateCardImage(file)) {
        this.uploadCardImage(file);
      }
      event.target.value = '';
    },
    validateCardImage: function validateCardImage(file) {
      var isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    uploadCardImage: function () {
      var _uploadCardImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var response, data;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.imageUploading = true;
              _context.prev = 1;
              _context.next = 2;
              return (0, _gift_card.uploadGiftCardImage)(file);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                data = response.data;
                this.currentImageUrl = this.imgAccessDomain + data.pathKey;
                this.uploadedImagePath = data.pathKey;
                this.$message.success('图片上传成功!');
              }
            case 3:
              _context.prev = 3;
              this.imageUploading = false;
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function uploadCardImage(_x) {
        return _uploadCardImage.apply(this, arguments);
      }
      return uploadCardImage;
    }(),
    saveCardImage: function saveCardImage() {
      var _this2 = this;
      if (!this.uploadedImagePath) {
        this.$message.warning('请先上传卡面图片');
        return;
      }
      this.imageSaving = true;
      (0, _physical_card.updatePhysicalCardImg)({
        fnId: this.currentEditRow.fnId,
        img: this.uploadedImagePath
      }).then(function () {
        _this2.$message.success('卡面更新成功');
        _this2.imageDialogVisible = false;
        _this2.currentEditRow.img = _this2.uploadedImagePath;
        _this2.imageSaving = false;
      }).catch(function () {
        _this2.imageSaving = false;
      });
    },
    formatTime: function formatTime(val) {
      if (!val) return '';
      var d = new Date(val);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    }
  }
};